export const mainTransitionDuration = 0.5
export const mainTransitionDelay = 0.2
export const mainEase = [0.17, 0.67, 0.51, 1]
export const fullTransitionTime = mainTransitionDuration + mainTransitionDelay
export const blurFilter = 'blur(10px)'
export const exitDuration = mainTransitionDelay + 0.1
export const exitEase = [0.67, 0.17, 0.62, 0.64]

export const modalDialogVariants = {
  initial: {
    opacity: 0,
    filter: blurFilter,
    z: -50,
    rotateY: 10,
    rotateX: 2,
    transformPerspective: 200,
    transition: {
      duration: exitDuration,
      ease: exitEase,
    },
  },
  open: {
    opacity: 1,
    filter: 'blur(0px)',
    rotateX: 0,
    rotateY: 0,
    z: 0,
    transition: {
      delay: mainTransitionDelay,
      duration: mainTransitionDuration,
      ease: mainEase,
      opacity: {
        delay: mainTransitionDelay,
        duration: mainTransitionDuration,
        ease: 'easeOut',
      },
    },
  },
}

export const modalHeaderVariants = {
  initial: {
    opacity: 0,
    filter: blurFilter,
    x: -50,
    transition: {
      duration: exitDuration,
      ease: exitEase,
    },
  },
  open: {
    opacity: 1,
    filter: 'blur(0px)',
    x: 0,
    transition: {
      delay: mainTransitionDelay,
      duration: mainTransitionDuration,
      ease: mainEase,
      opacity: {
        delay: mainTransitionDelay,
        duration: mainTransitionDuration,
        ease: 'easeOut',
      },
    },
  },
}

export const fullPageModalVariants = {
  initial: {
    opacity: 0,
    filter: blurFilter,
    scale: 0.8,
    transition: {
      duration: exitDuration,
      ease: exitEase,
    },
  },
  open: {
    opacity: 1,
    filter: 'blur(0px)',
    scale: 1,
    transition: {
      delay: mainTransitionDelay,
      duration: mainTransitionDuration,
      ease: mainEase,
      scale: {
        type: 'spring',
      },
      opacity: {
        delay: mainTransitionDelay,
        duration: mainTransitionDuration,
        ease: 'easeOut',
      },
    },
  },
}

export const modalSlideInVariants = {
  initial: {
    opacity: 0,
    filter: blurFilter,
    x: -50,
    transition: {
      duration: exitDuration,
      ease: exitEase,
    },
  },
  open: {
    opacity: 1,
    filter: 'blur(0px)',
    x: 0,
    transition: {
      delay: mainTransitionDelay,
      duration: mainTransitionDuration,
      ease: mainEase,
      opacity: {
        delay: mainTransitionDelay,
        duration: mainTransitionDuration,
        ease: 'easeOut',
      },
    },
  },
}
